import * as React from 'react';
import { useGetLocksLive } from './controller';
import { LocksContext } from './LocksContext';
var emptyArray = [];
/**
 * Fetches the locks for a resource on mount, and puts them in a LocksContext.
 * The locks are updated in real time.
 *
 * This component calls `dataProvider.getLocks()`, then subscribes to
 * the locks topic for the current resource, and refetches the locks
 * when a new event is received.
 *
 * @example
 * import { List, useRecordContext } from 'react-admin';
 * import { WithLocks, useLocksContext } from '@react-admin/ra-realtime';
 *
 * const LockField = () => {
 *    const locks = useLocksContext();
 *    const record = useRecordContext();
 *    if (!record) return null;
 *    const lock = locks.find(lock => lock.recordId === record?.id);
 *    if (!lock) return null;
 *    return <span>Locked by {lock.identity}</span>;
 * };
 *
 * const PostList = () => (
 *   <WithLocks>
 *     <List>
 *       <Datagrid>
 *         <TextField source="title" />
 *         <LockField />
 *       </Datagrid>
 *     </List>
 *   </WithLocks>
 * );
 */
export var WithLocks = function (_a) {
    var children = _a.children;
    var locks = useGetLocksLive().data;
    return (React.createElement(LocksContext.Provider, { value: locks || emptyArray }, children));
};
